import { SET_UPDATEUSERINVITEFRIEND } from '../actions';

const updateinvitefriend = (state = [], action) => {
  switch (action.type) {
	case SET_UPDATEUSERINVITEFRIEND:
      return [...action.value];  
    default: return state;
  }
}

export default updateinvitefriend;
